import * as React from 'react';
import {TooltipWithLink} from '../tooltipWithLink/TooltipWithLink';
import {InfoCircleOutlined} from '@ant-design/icons';

interface InfoIconProps {
  message: string | React.ReactNode;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  overlayClassName?: string;
  type?: string;
}

export const InfoIcon = ({
  message,
  color = 'var(--color-tooltip-icon)',
  overlayClassName = '',
  style = {},
  className = '',
  type,
}: InfoIconProps) => (
  <TooltipWithLink overlayClassName={overlayClassName} title={message}>
    {/*TODO removed filled*/}
    <InfoCircleOutlined style={{...style, color}} className={className} type={type} />
  </TooltipWithLink>
);
